import React, { Component } from "react";
import AppStyle from './AppStyle';
import { createBrowserHistory } from 'history';
import { Router, Switch, Route, Redirect } from "react-router-dom";
import { ThemeProvider } from "@material-ui/core/styles";
import FooterView from "./components/Footer/FooterView";
import OneShotRequestView from "./modules/OneShotRequest/OneShotRequestView";
import {StripeProvider} from 'react-stripe-elements';
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from '@date-io/date-fns';

export default class App extends Component {

    private _style = new AppStyle();
    public static _history = createBrowserHistory();

    render() 
    {
        // @ts-ignore
        const isIE = /*@cc_on!@*/false || !!document.documentMode;

        if(isIE)
        {
            return (
                <div>
                    Medicheck doesn't support Internet Explorer.
                    <br />
                    Please install Edge, Safari, Mozilla Firefox, Opera or Google Chrome.
                </div>
            );
        }

        return (
            <Router history={App._history}>
                <StripeProvider apiKey='pk_live_hzncDKtkTyx2dwJRoZdlie9M001r2mEmDS'>
                    <ThemeProvider theme={this._style.theme}>
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <div style={this._style.shell}>
                                <Switch>
                                    {/* Main component that controls the different steps of the request */}
                                    <Route path='/:language/one-shot' render={routeProps => <OneShotRequestView routeProps={routeProps} /> } />

                                    {/* Default component which will redirect to the one shot request */}
                                    <Route path='/:language' render={routeProps => (
                                        <Redirect to={`/${routeProps.match.params.language}/one-shot`} /> 
                                    )} />

                                    {/* Default component which will redirect to the english one shot request */}
                                    <Route path='/' render={() => (
                                        <Redirect to={`/en/one-shot`} /> 
                                    )} />
                                </Switch>

                                <FooterView />
                            </div>
                        </MuiPickersUtilsProvider>
                    </ThemeProvider>
                </StripeProvider>
            </Router>
        );  
    }
}